
export default {
  name1: "lcn",
  name2: "nail spa",
  phone: "9842025188",
  address: "12341 trickland rd, raleigh, NC 27613",
  directionLink:'https://goo.gl/maps/ARJLqm27ggFHW1aG6',
  bannerTitle: "Welcome to LCN Spa & Nails",
  bannerInfo:
    "Let Us Bring You Comfort & Relaxation. We offering an coupon of 10% discount for all new clients",
  aboutUs:
    "LCN Nails is proud of providing our customers with excellent services at affordable prices. Our well-trained, experienced & talented technicians with a positive attitude will bring customers comfort and relaxation with trending and new beauty techniques with decent prices every time crossing by. r pleasure to serve you at LCN Nail Spa.",
    coupon:'10% Discount for New Clients'
}
